<template>
  <modal-component :back="back">
    <div class="modal-container2">
      <div class="left">
        <div class="white-card" style="min-height: 300px">
          <div class="loader absolute" v-if="loading"></div>
          <h4 v-if="title" class="text-center my-2">{{ title }}</h4>
          <image-list :images="images"/>
        </div>

        <a download="" v-if="download" :href="download" target="_blank" class="btn btn-green btn-block my-2">Télécharger</a>

        <training-component v-if="has_quiz||has_exercises" :slug="slug" :has_exercises="has_exercises"
                            :has_quiz="has_quiz" style="margin-top: 60px;"/>
      </div>

      <div class="right" v-if="discussion_id">
        <chat-widget :discussion-id="discussion_id" class="fixed"></chat-widget>
      </div>
    </div>
  </modal-component>
</template>
<script>
import ModalComponent from "../../components/LayoutPartials/ModalComponent";
import TrainingComponent from "@/components/Lesson/TrainingComponent"
import axios from 'axios'
import ChatWidget from "@/components/Chat/ChatWidget";
import ImageList from "@/components/Lesson/ImageList";

export default {
  components: {
    ImageList,
    ChatWidget,
    TrainingComponent,
    ModalComponent,
  },
  data() {
    return {
      images: [],
      title: null,
      loading: false,
      back: null,
      slug: null,
      has_quiz: false,
      has_exercises: false,
      discussion_id: null,
      download: null
    }
  },
  computed: {
    lessonId() {
      return this.$slugId(this.$route.params.slug)
    },
    complete() {
      return !!this.$route.query.complete
    },
    type() {
      return this.complete ? 'course-complete' : 'course'
    }
  },
  mounted() {
    this.loading = true
    axios.get(`/lesson/${this.lessonId}/course_images`, {params: {complete: this.complete ? 1 : 0}})
      .then(({data}) => {
        this.images = data.images
        this.title = data.title
        this.back = {name: 'lesson', params: {slug: data.slug}}
        this.slug = data.slug
        this.has_quiz = data.has_quiz
        this.has_exercises = data.has_exercises
        this.discussion_id = data.discussion_id
        this.download = data.download
      })
      .then(() => this.loading = false)
  }
};
</script>

<style lang="scss" scoped>


</style>
